import m from "react";
import { f, b as p, a as l, c as d, P as e } from "./javascript.esm-BKBSEq3-.js";
import { css as y, cx as h } from "@emotion/css";
import { t as s } from "./toDate-DF9e2eS8.js";
const u = {
  fontFamily: f.body,
  fontSize: p.default,
  lineHeight: 1.2,
  fontWeight: l.regular,
  color: d.jumbo
}, T = {
  wrapper: y(u)
}, g = ({ className: t, children: o }) => /* @__PURE__ */ m.createElement("div", { className: h(T.wrapper, t) }, o);
g.propTypes = {
  children: e.oneOfType([e.arrayOf(e.node), e.node]),
  className: e.string
};
function w(t, o) {
  const a = +s(t), [r, n] = [
    +s(o.start),
    +s(o.end)
  ].sort((i, c) => i - c);
  return a >= r && a <= n;
}
const W = (t) => w(/* @__PURE__ */ new Date(), { start: t.start, end: t.end });
export {
  g as T,
  W as s,
  u as t
};
